import React from 'react';
import ReactDOM from 'react-dom';
import Header from './components/Header';
import VideoFormContainer from './components/VideoFormContainer';
import Footer from './components/Footer';
import LogoAgentContainer from './components/LogoAgentContainer';
import RelatedVideos from './components/RelatedVideos';
import Modal from './components/Modal';
import StickyRightButton from './components/StickyRightButton';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vidkey: "",
            videoFkey: "",
            vehicleFkey: "",
            shareUrl: "",
            header: "",
            dealerName: "",
            dealerNameMissing: "",
            disclaimer: "",
            dealer: "",
            logo: "",
            agent: "",
            video: "",
            form: "",
            footer: "",
            templateId: "",
            templateName: "",
            selectedThemeId: "",
            videoCall: "",
            pageStyles: "",
            preview: false,
            showShortDesc: false,
            trackingCode: "",
            GATrackingId:"",
            videoOrientation:"",
            baseUrl: this.getBaseUrl(),
            //baseUrl : window.location.protocol+"//"+window.location.hostname,
            lpUrl: "/LP/index_json.php",
            lpEndUrl : "&RUN_TYPE=LP_FULL_PAGE_JSON",
            // lpEndUrl: "?video_fk=&tmeplateId=18&template_domain_id=228&email=2&RUN_TYPE=LP_FULL_PAGE_JSON",
            rvEndUrl: "&RUN_TYPE=LP_RELATED_VIDEOS_JSON",
            backgroundImageVal: '',
            siteCss:''
        };
        this.loadRelatedVideo = this.loadRelatedVideo.bind(this);
        this.loadData = this.loadData.bind(this);
        this.switchTheme = this.switchTheme.bind(this);
        this.getQueryStringValue = this.getQueryStringValue.bind(this);
        this.switchTheme = this.switchTheme.bind(this);
        this.changeTheme = this.changeTheme.bind(this);
        this.handleExpandText = this.handleExpandText.bind(this);
        this.appendGAScript = this.appendGAScript.bind(this);
        this.loadMetaData = this.loadMetaData.bind(this);
        this.getBaseUrl = this.getBaseUrl.bind(this);
        this.detectIosDevice = this.detectIosDevice.bind(this);
        this.sendHeightToIframeParent = this.sendHeightToIframeParent.bind(this);
    }

    getBaseUrl() {
        const baseUrl = document.getElementById('BASE_URL_DIV').getAttribute('data-baseUrl');
        const urls = baseUrl.split(':');
        if (window.location.protocol === 'http:') {
            return window.location.protocol + urls[0];
        } else if (window.location.protocol === 'https:') {
            return window.location.protocol + baseUrl;
        }
        // console.log(this.state.baseUrl);
    }

    detectIosDevice() {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    }

    sendHeightToIframeParent() {
        window.parent.postMessage(JSON.stringify({ height: document.body.scrollHeight }), "*");
    }


    loadRelatedVideo(relatedVideo, event) {
        event.preventDefault();
        if (this.state.preview) {
            return false;
        }
        // console.log("relatedVideo.main_title", relatedVideo.main_title);
        let video = {
            title: relatedVideo.main_title,
            description: relatedVideo.description,
            meta_description: relatedVideo.meta_description,
            source: relatedVideo.source,
            poster: relatedVideo.poster,
            video_fk: relatedVideo.video_fk,
            vin: relatedVideo.vin,
            stock: relatedVideo.stock,
            tabbed_player: relatedVideo.tabbed_player,
            isPlayerPano: relatedVideo["360_player"],
            videoOrientation:relatedVideo['video_orientation']
            // main_title: relatedVideo.main_title

        }

        this.setState({ video: video }, function () {
            this.loadMetaData(video.title, video.poster, this.state.dealerName, video.meta_description);
        });

    }

    componentWillMount() {
        //  if(this.detectIosDevice()) document.body.classList.add("ios-device");
        const that = this;
        this.loadData();
        let domainId = this.getQueryStringValue("template_domain_id");

        if (domainId.length > 0) {
            this.setState({ preview: true }, function () {
                (function () {
                    var theBody = document.getElementsByTagName('body')[0];
                    var currentHeight = theBody.offsetHeight;
                    var sendPostMessageUpdate = function () {
                        window.parent.postMessage(JSON.stringify({ height: (theBody.offsetHeight + 1) }), "*");
                        currentHeight = theBody.offsetHeight;
                        // console.log('currentHeight', currentHeight);
                    }
                    setInterval(function () {
                        // If the content height has changed, send a postMessage
                        if (currentHeight !== theBody.offsetHeight) {
                            sendPostMessageUpdate();
                        }
                    }, 100);
                    // Initial resize postMessage
                    sendPostMessageUpdate();
                })();
            });
        }

        function getBodyWidth() {
            let bd = document.querySelector("body").offsetWidth;
            that.setState({ bodyWidth: bd });
        }

        getBodyWidth();
        const self = this;

        window.onorientationchange = function () {
            //console.log("orientation changed");
            self.sendHeightToIframeParent();
            setTimeout(self.sendHeightToIframeParent, 500);
            setTimeout(self.sendHeightToIframeParent, 1000);
            setTimeout(self.sendHeightToIframeParent, 2000);
        }

        window.onresize = function () {
            //console.log("window resized");
            getBodyWidth();
            self.sendHeightToIframeParent();
            setTimeout(self.sendHeightToIframeParent, 500);
            setTimeout(self.sendHeightToIframeParent, 1000);
            setTimeout(self.sendHeightToIframeParent, 2000);
        }
        // document.addEventListener('touchstart', {});
        this.sendHeightToIframeParent();
        setTimeout(this.sendHeightToIframeParent, 500);
        setTimeout(this.sendHeightToIframeParent, 1000);
        setTimeout(this.sendHeightToIframeParent, 2000);
        setTimeout(this.sendHeightToIframeParent, 3000);
        setTimeout(this.sendHeightToIframeParent, 5000);
        setTimeout(this.sendHeightToIframeParent, 7000);

    }

    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    switchTheme(event) {
        let btn = event.target;
        let selectedThemeId = btn.previousElementSibling.value;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {

            }
        };

        let url = this.state.baseUrl + "/ava/admin/index.php?APP_TYPE=CLIENTS&RUN_TYPE=SAVE_EMAIL_THEME&video_fk=&type=&theme=" + selectedThemeId + "&domainId=" + this.state.templateId + "&page_type=LP"
        xhttp.open("GET", url, true);
        xhttp.send();
    }

    changeTheme(event) {
        let selectedThemeId = event.target.value;
        let colors;
        for (let i = 0; i < this.state.themes.length; i++) {
            if (this.state.themes[i].theme_id === selectedThemeId) {
                colors = JSON.parse(this.state.themes[i].theme_style_colors);
            }
        }
        this.setState({ pageStyles: colors }, function () {

        });
    }

    handleExpandText(event) {
        let expandLink = event.target;
        event.preventDefault();
        if (event.target.textContent === "Show more") {
            this.setState({ showShortDesc: true });
            expandLink.style.display = "none";
            expandLink.nextSibling.style.display = "block";
            expandLink.nextSibling.style.transition = "0.3s";
        } else {
            this.setState({ showShortDesc: false });
            expandLink.style.display = "none";
            expandLink.previousSibling.style.display = "block";
            expandLink.previousSibling.style.transition = "0.3s";
        }
    }

    closeModal(el) {
        el.style.display = "none";
    }

    appendGAScript(scriptCode) {
        if (!scriptCode) {
            return false;
        }

        let sciptLocation = document.head;

        // let docBody = document.getElementsByTagName('body')[0];
        scriptCode = scriptCode.replace("<script>", "");
        scriptCode = scriptCode.replace("</script>", "");
        scriptCode = scriptCode.replace("<!-- Google Analytics -->", "");
        scriptCode = scriptCode.replace("<!-- End Google Analytics -->", "");
        scriptCode = scriptCode.trim(scriptCode);
        let scriptObj = document.createElement("SCRIPT");
        scriptObj.type = 'text/javascript';
        scriptObj.textContent = scriptCode;
            sciptLocation.appendChild(scriptObj);
    }

    loadMetaData(title, image, siteName, desc) {
        title = title || "";
        image = image || "";
        siteName = siteName || "";
        desc = desc || "";

        let ogTitle = document.querySelector('[property="og:title"]');
        let ogImage = document.querySelector('[property="og:image"]');
        let ogSiteName = document.querySelector('[property="og:site_name"]');
        let ogDesc = document.querySelector('[property="og:description"]');

        // ogTitle.setAttribute("content", title);
        // ogImage.setAttribute("content", image);
        // ogSiteName.setAttribute("content", siteName);
        // ogDesc.setAttribute("content", desc);
    }

    loadData() {
        // console.log('baseurl', this.state.baseUrl);
        const baseUrl = this.state.baseUrl;
        let lpUrl = this.state.lpUrl;
        let urlParmas = window.location.search;
        let endUrl = this.state.lpEndUrl;
        let pageData = null;
        const xhttp = new XMLHttpRequest();
        const that = this;
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                try {
                    pageData = JSON.parse(this.responseText);
                    // console.log('JSON.parse(pageData["page_style"])',JSON.parse(pageData["page_style"]).themeImage);
                    if (pageData["lp_internal_name"] === "SOCIALIZE" ||
                        pageData["lp_internal_name"] === "SOCIALIZE_FOOTER" || pageData['show_no_vid']) {
                        pageData["page_style"] = JSON.stringify({
                            "headerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "footerStyle": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "caption-title": { "backgroundColor": "#495FA6", "color": "#FFF" },
                            "header-bar": { "borderTop": "8px solid #749BDB" },
                            "sidebar": { "backgroundColor": "#749BDB", "color": "#FFF" },
                            "triagle1": { "borderRightColor": " #6C9DED" },
                            "triagle2": { "borderLeftColor": "#5284D5" },
                            "btn-primary": {
                                "backgroundColor": "#3498db",
                                "hoverBg": "#0c86d8"
                            },
                            "submit-btn": {
                                "backgroundColor": "#3498db",
                                "hoverBg": "#0c86d8"
                            },
                            "btn": [{ "focus": { "backgroundColor": "#0c86d8" } },
                            { "active": { "focus": { "backgroundColor": "#0c86d8" } } }],
                            "btn.active": { "focus": { "backgroundColor": "#0c86d8" } }
                        });
                    }
                } catch (error) {
                    console.log(error);
                    return;
                }

                that.setState({
                    vidkey: pageData["email_guid"],
                    videoFkey: pageData["video_fkey"],
                    vehicleFkey: pageData["vehicle_fkey"],
                    shareUrl: pageData["share_url"],
                    templateId: pageData["lp_internal_name"],
                    templateName: pageData["lp_template_name"],
                    selectedThemeId: pageData['lp_selected_theme_id'],
                    dealerName: pageData["dealer-name"],
                    dealerEmail: pageData["dealer-email"],
                    dealerNameMissing: pageData["dealer-name_missing"],
                    dealer: pageData['dealer'],
                    header: pageData['header'],
                    logo: pageData["logo-src"],
                    agent: pageData['agent'],
                    video: pageData["video"],
                    form: pageData['form'],
                    lpForm: pageData['lp_form'],
                    footer: pageData["footer"],
                    videoCall: pageData["video_call"],
                    pageStyles: JSON.parse(pageData["page_style"]),
                    themes: pageData["theme_rows"],
                    trackingCode: pageData["template_tracking_code"],
                    GATrackingId:pageData["cs_guaid"] ? pageData["cs_guaid"] : '',
                    show_no_vid: pageData["show_no_vid"],
                    disclaimer: pageData["template_disclaimer"],
                    backgroundImageVal: (JSON.parse(pageData["page_style"]) && JSON.parse(pageData["page_style"]).themeImage) ? (JSON.parse(pageData["page_style"]).themeImage) : '',
                    siteCss:(JSON.parse(pageData["page_style"]) && JSON.parse(pageData["page_style"]).siteCss) ? (JSON.parse(pageData["page_style"]).siteCss) : ''

                    // player_pano     : this.state.video.isPlayerPano
                }, function () {
                    //  console.log("dealerName", this.state.dealerName);
                    this.appendGAScript(this.state.trackingCode);
                    if (typeof this.state.video !== "undefined") {
                        this.loadMetaData(this.state.video.title, this.state.video.poster, this.state.dealerName, this.state.video.meta_description);
                    }
                });
            }
        };        

        xhttp.open("GET", baseUrl + lpUrl + urlParmas + endUrl, true);
        // console.log(baseUrl+lpUrl+urlParmas+endUrl);
        //xhttp.open("GET", "json/galaxy.json", true );
        xhttp.send();
    }

    render() {

        let finalRender;

        if (typeof this.state.templateId === "undefined") {
            finalRender = <div>Loading...</div>
        } else {
            let themeStyle = document.createElement("style");
            themeStyle.innerText = this.state.siteCss;
            document.head.appendChild(themeStyle);

            let themeBg = {
                // "backgroundImage": "url(" + this.state.baseUrl + "/NLP/public/images/" + this.state.backgroundImageVal.backgroundImage + ")",
                "color": this.state.backgroundImageVal.color,
            }

            if (this.state.templateId === "THEATER_CONTACT_FOOTER" ||
                this.state.templateId === "THEATER_FOOTER" ||
                this.state.templateId === "CROSSBAR_FOOTER" ||
                this.state.templateId === "CROSSBAR_LEFT_FOOTER" ||
                this.state.templateId === "LINKED_UP_FOOTER" ||
                this.state.templateId === "SOCIALIZE_FOOTER" ||
                this.state.templateId === "GET_STARTED_FOOTER" ||
                this.state.templateId === "LINKED_UP_LEFT_FOOTER" ||
                this.state.templateId === "NEWSLETTER_FOOTER" ||
                this.state.templateId === "TABBED_THEATER_FOOTER" || 
                this.state.templateId === "LP_LINKS_WITH_ICONS") {

                finalRender = <div className="theme" style={themeBg}>
                    <Modal
                        shareurl={this.state.shareUrl}
                        lpForm={this.state.lpForm} />
                    <Header
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks} />

                    <VideoFormContainer
                        handleExpandText={this.handleExpandText}
                        showShortDesc={this.state.showShortDesc}
                        lpForm={this.state.lpForm}
                        template={this.state.templateId}
                        links={this.state.header.headerLinks}
                        styles={this.state.pageStyles}
                        video={this.state.video}
                        form={this.state.form}
                        shareurl={this.state.shareUrl}
                        agent={this.state.agent}
                        dealerName={this.state.dealerName}
                        preview={this.state.preview}
                        bodyWidth={this.state.bodyWidth}
                        disclaimer={this.state.disclaimer}
                        playerPano={this.state.player_pano}
                        GATrackingId={this.state.GATrackingId}
                        videoOrientation={this.state.videoOrientation}
                    />

                    <RelatedVideos
                        baseurl={this.state.baseUrl}
                        preview={this.state.preview}
                        handleLoadVideo={this.loadRelatedVideo}
                        template={this.state.templateId}
                        videos={this.state.relatedVideos}
                        vidkey={this.state.vidkey}
                        video_fk={this.state.video.video_fk}
                        vehicleFkey={this.state.vehicleFkey}
                        backgroundImageVal={this.state.backgroundImageVal}
                    />

                    <Footer
                        template={this.state.templateId}
                        styles={this.state.pageStyles}
                        footer={this.state.footer} />

                    <LogoAgentContainer
                        styles={this.state.pageStyles}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        logo={this.state.logo}
                        agent={this.state.agent}
                        video_fk={this.state.video.video_fk}
                        dealerName={this.state.dealerName}
                        dealerEmail={this.state.dealerEmail}
                        backgroundImageVal={this.state.backgroundImageVal}
                        preview={this.state.preview} 
                        dealerUrl={this.state.dealer.dealer_url}/>

                    <StickyRightButton
                        videoCall={this.state.videoCall} />
                </div>
            } else {
                finalRender = <div className="theme" style={themeBg}>
                    <Modal
                        shareurl={this.state.shareUrl}
                        lpForm={this.state.lpForm} />

                    <Header
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks} />

                    <LogoAgentContainer
                        styles={this.state.pageStyles}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        logo={this.state.logo}
                        agent={this.state.agent}
                        video_fk={this.state.video.video_fk}
                        dealerName={this.state.dealerName}
                        dealerEmail={this.state.dealerEmail}
                        backgroundImageVal={this.state.backgroundImageVal}
                        preview={this.state.preview} 
                        dealerUrl={this.state.dealer.dealer_url}/>

                    <VideoFormContainer
                        handleExpandText={this.handleExpandText}
                        showShortDesc={this.state.showShortDesc}
                        lpForm={this.state.lpForm}
                        agent={this.state.agent}
                        template={this.state.templateId}
                        links={this.state.header.headerLinks}
                        styles={this.state.pageStyles}
                        video={this.state.video}
                        form={this.state.form}
                        shareurl={this.state.shareUrl}
                        dealerName={this.state.dealerName}
                        preview={this.state.preview}
                        bodyWidth={this.state.bodyWidth}
                        disclaimer={this.state.disclaimer}
                        playerPano={this.state.player_pano}
                        themes={this.state.themes}
                        selectedThemeId={this.state.selectedThemeId}
                        GATrackingId={this.state.GATrackingId}
                        videoOrientation={this.state.videoOrientation}
                    />

                    <RelatedVideos
                        baseurl={this.state.baseUrl}
                        handleLoadVideo={this.loadRelatedVideo}
                        videos={this.state.relatedVideos}
                        vidkey={this.state.vidkey}
                        video_fk={this.state.video.video_fk}
                        vehicleFkey={this.state.vehicleFkey}
                        preview={this.state.preview}
                        themes={this.state.themes}
                        switchTheme={this.switchTheme}
                        selectedThemeId={this.state.selectedThemeId}
                        changeTheme={this.changeTheme}
                        shareurl={this.state.shareUrl}
                        template={this.state.templateId}
                        dealer={this.state.dealer}
                        styles={this.state.pageStyles}
                        dealerName={this.state.dealerName}
                        dealernamemissing={this.state.dealerNameMissing}
                        toplinks={this.state.header.headerLinks}
                        lpForm={this.state.lpForm}
                        backgroundImageVal={this.state.backgroundImageVal}
                    />

                    <Footer
                        template={this.state.templateId}
                        styles={this.state.pageStyles}
                        footer={this.state.footer} />

                    <StickyRightButton
                        videoCall={this.state.videoCall} />
                </div>
            }
        }

        if (this.state.show_no_vid) {
            finalRender = <div><img src={this.state.show_no_vid} alt="..." /></div>;
        }

        return (finalRender);
    };
}

ReactDOM.render(
    <App />, document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/index.js